// BOOKING PAGE, SELFSERVICE (personal details + services) -----

// Import shared
require('./shared')

// Import components
require('../../components/img/main')

// Import widgets
require('../../widgets/booked-service-basket/main')
require('../../widgets/booked-service-error/main')
require('../../widgets/booked-services-list/main')
require('../../widgets/booked-service-navigation/main')
require('../../widgets/booking-awaitable-popup/main')
require('../../widgets/booking-back-button/main')
require('../../widgets/booking-bundle/main')
require('../../widgets/booking-cancellation-flow/main')
require('../../widgets/booking-car-rental/main')
require('../../widgets/booking-changed-notification/main')
require('../../widgets/booking-choice-list/main')
require('../../widgets/booking-comparison-table/main')
require('../../widgets/booking-filterable-services/main')
require('../../widgets/booking-luggage/main')
require('../../widgets/booking-message/main')
require('../../widgets/rebooking-options/main')
require('../../widgets/personal-details-edit/main')
require('../../widgets/booking-terms-conditions/main')
require('../../widgets/action-modal/main')
require('../../widgets/download-documents/main')
require('../../widgets/excursions/main')
require('../../widgets/transfer-summary/main')
require('../../widgets/account-special-luggage/main')

// This widget should be the last to be required
require('../../widgets/booked-service-edit/main')

require('../../../js/core/widget/widget-api')

// Autoload all components when the page is ready
const { autoload } = require('../../../js/document/load-queue')
autoload()
